import React from 'react';
import { useTranslation } from 'react-i18next';
import './Hero.css';

const Hero = () => {
  const { t } = useTranslation();

  const handleStartNow = () => {
    // Get the app URL from environment or use a default
    const appUrl = process.env.REACT_APP_APP_URL || 'https://glowapp.foo-tech.net';
    // Open the app URL in a new tab/window
    if (appUrl) {
      window.open(appUrl, '_blank');
    } else {
      console.error('App URL not configured');
    }
  };

  return (
    <section className="hero" aria-label="Hero section">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">{t('heroTitle')}</h1>
            <h2 className="hero-subtitle">{t('heroSubtitle')}</h2>
            <p className="hero-description">{t('heroDescription')}</p>
            <div className="hero-cta">
              <button onClick={handleStartNow} className="btn btn-primary btn-large">
                {t('startNow')}
              </button>
              <a href="#features" className="btn btn-secondary btn-large">
                {t('learnMore')}
              </a>
            </div>
          </div>
          <div className="hero-image">
            <div className="phone-mockup" aria-label="GlowApp mobile app preview">
              <div className="phone-screen">
                <div className="app-screenshot">
                  <div className="screenshot-placeholder" role="img" aria-label={t('appScreenshot')}>
                    <span className="placeholder-icon" aria-hidden="true">📱</span>
                    <p>{t('appScreenshot')}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
